import {
    CHILD_OBJECT_INVALID,
    NODE_DATA_INVALID,
    PARENT_OBJECT_INVALID,
    PARENT_TYPE_INVALID,
    Schema,
} from '@gitbook/slate';

import { BLOCK_HINT, BLOCKS, FRAGMENT_EXPANDABLE_BODY, FRAGMENT_TABLE_CELL } from '../types';
import { unwrapChildren, wrapInlinesInParagraph } from '../utils';

/**
 * Schema to validate hint blocks.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_HINT]: {
            parent: {
                objects: ['document', 'fragment', 'block'],
                types: [undefined, ...BLOCKS, FRAGMENT_EXPANDABLE_BODY, FRAGMENT_TABLE_CELL],
            },
            nodes: [{ objects: ['block'], min: 1 }],
            data: {
                style: (value) => ['info', 'warning', 'danger', 'success'].includes(value),
                icon: (value) => value === undefined || typeof value === 'string',
            },
            normalize: Schema.createNormalize({
                [PARENT_OBJECT_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [PARENT_TYPE_INVALID]: (change, context) => unwrapChildren(change, context.node),
                [CHILD_OBJECT_INVALID]: (change, context) =>
                    // @ts-expect-error
                    wrapInlinesInParagraph(change, context.node.key),
                [NODE_DATA_INVALID]: (change, context) =>
                    // @ts-expect-error
                    change.setNodeByKey(context.node.key, { data: { style: 'info' } }),
            }),
        },
    },
});
